import React from 'react';
import { API_BASE } from '../config';
import { Navbar } from '../components/Navbar';

export class TeamsPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            teams: [],
        }

    }

    componentDidMount() {
        this.getTeams();
    }

    getTeams() {
        fetch(`${API_BASE}/teams`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            },
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        }).then(response => {
            this.setState({
                teams: response
            });
        }).catch(error => console.log(error.message));
    }

    render() {
        return (
            <>
                <Navbar history={this.props.history}></Navbar>
                <div className="teams-page">
                    <div className="teams-page-header">
                        <h1>eSports Teams</h1>
                    </div>
                    <div className="teams-page-list">
                        {this.state.teams.map((team, index) => (
                            <div key={index} className="teams-page-list-item">
                                <div className="teams-page-list-item-name">{team.name}</div>
                                <div className="teams-page-list-item-members">
                                    <div className="teams-page-list-item-members-list">
                                        {team.members.map((member, index) => (
                                            <div key={index} className="teams-page-list-item-members-list-item">
                                                <div className="teams-page-list-item-members-list-item-avatar">
                                                    <img src="https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50?s=200" alt="avatar" />
                                                </div>
                                                <div className="teams-page-list-item-members-list-item-name">{member.name}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </>
        );
    }
}